import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AuthPageLayoutComponent } from './layouts/auth-page-layout/auth-page-layout.component';
import { BasePageLayoutComponent } from './layouts/base-page-layout/base-page-layout.component';
import { IllustrationPageLayoutComponent } from './layouts/illustration-page-layout/illustration-page-layout.component';
import { ConfirmationComponent } from './messaging/confirmation/confirmation.component';
import { EmptyTableStateComponent } from './states/empty-table-state/empty-table-state.component';
import { TopNavComponent } from './top-nav/top-nav.component';
import {RouterModule} from '@angular/router';

@NgModule({
  imports: [CommonModule, FontAwesomeModule, NgbModule, RouterModule],
  declarations: [
    TopNavComponent,
    EmptyTableStateComponent,
    BasePageLayoutComponent,
    IllustrationPageLayoutComponent,
    AuthPageLayoutComponent,
    ConfirmationComponent
  ],
  exports: [
    TopNavComponent,
    EmptyTableStateComponent,
    BasePageLayoutComponent,
    IllustrationPageLayoutComponent,
    AuthPageLayoutComponent,
    ConfirmationComponent
  ]
})
export class CustomCelerityComponents {}
